export default function TextInput({ placeholder, type = "text", required = false, value, onChange, inputClass}) {
  return (
    <input 
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className={inputClass} />
  )
}